/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Praveen's Portfolio",
  description:
    "Innovative Senior Data Engineer specializing in architecting scalable, high-performance data pipelines and cloud infrastructure. Expertise in advanced analytics, big data solutions, and deploying AI-driven applications for transformative business insights..",
  og: {
    title: "Praveen Kumar Portfolio",
    type: "website",
    url: "http://praveensamineni.com/",
  },
};

//Home Page
const greeting = {
  title: "Praveen Kumar",
  logo_name: "PraveenKumar",
  nickname: "data_engineer",
  subTitle:
    "Innovative Senior Data Engineer specializing in architecting scalable, high-performance data pipelines and cloud infrastructure. Expertise in advanced analytics, big data solutions, and deploying AI-driven applications for transformative business insights.",
  resumeLink:
    "https://drive.google.com/file/d/1OLaHW7Zq60NuweVvp_3KN9Uu-nuWoF0E/view?usp=sharing",
  portfolio_repository: "https://github.com/praveensamineni94",
  githubProfile: "https://github.com/praveensamineni94",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/praveensamineni94",
    fontAwesomeIcon: "fa-github",
    backgroundColor: "#181717",
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/praveen-k-93b7a2224/",
    fontAwesomeIcon: "fa-linkedin-in",
    backgroundColor: "#0077B5",
  },
  {
    name: "Gmail",
    link: "mailto:praveensamineni.dev@gmail.com",
    fontAwesomeIcon: "fa-google",
    backgroundColor: "#D14836",
  },
  {
    name: "Twitter",
    link: "https://x.com/praveen4758",
    fontAwesomeIcon: "fa-x-twitter",
    backgroundColor: "#000000",
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
];

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Designing and deploying advanced machine learning models for predictive analytics, classification, and anomaly detection.",
        "⚡ Proficient in deep learning frameworks for model optimization and fine-tuning, with a focus on scalable AI solutions.",
        "⚡ Expertise in statistical analysis, A/B testing, and hypothesis-driven data modeling for business insights.",
        "⚡ Hands-on experience with modern AI architectures like Transformers, LLMs, and Generative AI models.",
      ],
      softwareSkills: [
        {
          skillName: "TensorFlow",
          fontAwesomeClassname: "logos-tensorflow",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: { backgroundColor: "transparent" },
        },
        {
          skillName: "Scikit-learn",
          fontAwesomeClassname: "simple-icons:scikitlearn",
          style: { backgroundColor: "transparent", color: "#F7931E" },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: { backgroundColor: "white", color: "#D00000" },
        },
        {
          skillName: "Transformers (Hugging Face)",
          fontAwesomeClassname: "simple-icons:huggingface",
          style: { backgroundColor: "transparent", color: "#FFBF00" },
        },
        {
          skillName: "OpenAI GPT",
          fontAwesomeClassname: "simple-icons:openai",
          style: { backgroundColor: "transparent", color: "#412991" },
        },
        {
          skillName: "LangChain",
          fontAwesomeClassname: "simple-icons:langchain",
          style: { backgroundColor: "transparent", color: "#00A67E" },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: { backgroundColor: "transparent", color: "#3776AB" },
        },
        {
          skillName: "Jupyter",
          fontAwesomeClassname: "simple-icons:jupyter",
          style: { backgroundColor: "transparent", color: "#F37626" },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: { backgroundColor: "transparent", color: "#150458" },
        },
        {
          skillName: "Matplotlib",
          fontAwesomeClassname: "simple-icons:matplotlib",
          style: { backgroundColor: "transparent", color: "#11557C" },
        },
      ],
    },
    {
      title: "Data Engineering & ETL",
      fileName: "DataEngineerImg",
      skills: [
        "⚡ Designing robust, fault-tolerant data pipelines and architectures for large-scale data processing.",
        "⚡ Expertise in ETL workflows, data warehousing, and big data ecosystem management.",
        "⚡ Implementing real-time data streaming solutions and optimizing batch processing for performance.",
        "⚡ Hands-on experience with distributed computing frameworks and orchestration tools.",
      ],
      softwareSkills: [
        {
          skillName: "Apache Spark",
          fontAwesomeClassname: "simple-icons:apachespark",
          style: { color: "#E25A1C" },
        },
        {
          skillName: "Databricks",
          fontAwesomeClassname: "simple-icons:databricks",
          style: { color: "#FF3621" },
        },
        {
          skillName: "AWS Glue",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: { color: "#FF9900" },
        },
        {
          skillName: "Apache Kafka",
          fontAwesomeClassname: "simple-icons:apachekafka",
          style: { color: "#231F20" },
        },
        {
          skillName: "Snowflake",
          fontAwesomeClassname: "simple-icons:snowflake",
          style: { color: "#29B5E8" },
        },
        {
          skillName: "Airflow",
          fontAwesomeClassname: "simple-icons:apacheairflow",
          style: { color: "#017CEE" },
        },
        {
          skillName: "SQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: { color: "#4479A1" },
        },
        {
          skillName: "DBT",
          fontAwesomeClassname: "simple-icons:dbt",
          style: { color: "#FF694B" },
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building dynamic, scalable front-end applications using React and Redux.",
        "⚡ Developing RESTful APIs and microservices with Node.js, Express, and Python frameworks like Django and Flask.",
        "⚡ Integrating cloud-based services and databases for seamless full-stack development.",
        "⚡ Implementing secure authentication and authorization mechanisms in modern web applications.",
      ],
      softwareSkills: [
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: { color: "#61DAFB" },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: { color: "#339933" },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: { backgroundColor: "#000000", color: "#F7DF1E" },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: { color: "#E34F26" },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: { color: "#1572B6" },
        },
        {
          skillName: "Express",
          fontAwesomeClassname: "simple-icons:express",
          style: { color: "#000000" },
        },
        {
          skillName: "Redux",
          fontAwesomeClassname: "simple-icons:redux",
          style: { color: "#764ABC" },
        },
        {
          skillName: "TypeScript",
          fontAwesomeClassname: "simple-icons:typescript",
          style: { color: "#3178C6" },
        },
        {
          skillName: "Django",
          fontAwesomeClassname: "simple-icons:django",
          style: { color: "#092E20" },
        },
        {
          skillName: "Flask",
          fontAwesomeClassname: "simple-icons:flask",
          style: { color: "#000000" },
        },
      ],
    },
    {
      title: "Cloud Infrastructure & DevOps",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Deploying and managing cloud-native applications across AWS, GCP, and Azure.",
        "⚡ Automating CI/CD pipelines and infrastructure management using Infrastructure as Code (IaC) tools.",
        "⚡ Expertise in containerization with Docker and orchestration using Kubernetes for scalable deployments.",
        "⚡ Integrating cloud services for data engineering workflows and machine learning model deployments.",
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: { color: "#FF9900" },
        },
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: { color: "#4285F4" },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: { color: "#0089D6" },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: { color: "#1488C6" },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: { color: "#326CE5" },
        },
        {
          skillName: "Terraform",
          fontAwesomeClassname: "simple-icons:terraform",
          style: { color: "#623CE4" },
        },
        {
          skillName: "GitHub Actions",
          fontAwesomeClassname: "simple-icons:githubactions",
          style: { color: "#2088FF" },
        },
        {
          skillName: "Jenkins",
          fontAwesomeClassname: "simple-icons:jenkins",
          style: { color: "#D24939" },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/u/DataAlchemy/",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/profile/praveensamineni2",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/happy_hill_41",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "https://www.codechef.com/users/happy_hill_41",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      https: "//www.hackerearth.com/@praveensamineni.dev",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/praveensamineni",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Stevens Institute of Technology",
      subtitle: "Master of Science in Data Science",
      logo_path: "stevens_logo.png",
      alt_name: "SRM Institute of Technology",
      duration: "2016 - 2020",
      descriptions: [
        "⚡ Studied courses related to Big Data, Cloud Computing, and Data Engineering.",
        "⚡ Worked on projects involving Apache Spark, AWS, and real-time data processing.",
      ],
      website_link: "https://www.stevens.edu/",
    },
    {
      title: "SRM Institute of Technology",
      subtitle: "Bachelor’s in Computer Science",
      logo_path: "srm_logo.png",
      alt_name: "SRM Institute of Technology",
      duration: "2012 - 2016",
      descriptions: [
        "⚡ Studied fundamental Computer Science subjects including Algorithms, DBMS, OS, and Cloud Computing.",
        "⚡ Built multiple projects on Data Analytics and Software Development.",
      ],
      website_link: "https://www.srmist.edu.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.credly.com/badges/6b2b36dc-d102-4d16-b0b0-4807dbf764c6/linked_in?t=skqdvj",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.credly.com/badges/6b2b36dc-d102-4d16-b0b0-4807dbf764c6/linked_in?t=skqdvj",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.credly.com/badges/6b2b36dc-d102-4d16-b0b0-4807dbf764c6/linked_in?t=skqdvj/",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Data Science",
      subtitle: "- Alex Aklson",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.credly.com/badges/6b2b36dc-d102-4d16-b0b0-4807dbf764c6/linked_in?t=skqdvj/",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work Experience",
  description:
    "I have a diverse background in data engineering, data modeling, and analytics, having worked with various industries to develop scalable data solutions.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      work: true,
      experiences: [
        {
          title: "Senior Data Engineer",
          company: "Wayside Publishing",
          company_url: "https://waysidepublishing.com/",
          logo_path: "wayside_logo.png",
          duration: "June 2023 - Present",
          location: "Freeport, ME, USA",
          description:
            "Spearheaded the development of an end-to-end analytics infrastructure using AWS and Apache Spark, optimized workflows, and built interactive dashboards in Tableau and Power BI.",
          color: "#FF5733",
        },
        {
          title: "Senior Data and Analytics Engineer",
          company: "Washington Metropolitan Area Transit Authority (WMATA)",
          company_url: "https://wmata.com/",
          logo_path: "wmata_logo.png",
          duration: "May 2022 - May 2023",
          location: "Washington, DC, USA",
          description:
            "Led development of scalable ETL pipelines and unified transit data platforms, enhancing KPI tracking and data-driven decision-making.",
          color: "#4287f5",
        },
        {
          title: "Senior Data Modeler and Analytics Engineer",
          company: "Medtronic",
          company_url: "https://www.medtronic.com/",
          logo_path: "muffito_logo.png",
          duration: "April 2021 - May 2022",
          location: "Boston, MA, USA",
          description:
            "Architected secure, large-scale data pipelines for healthcare analytics, collaborated on predictive models with AWS SageMaker, and ensured HIPAA compliance.",
          color: "#00aaff",
        },
        {
          title: "Data Analyst/Modeler",
          company: "Fission Labs",
          company_url: "https://www.fissionlabs.com/",
          logo_path: "freecopy_logo.png",
          duration: "April 2016 - September 2019",
          //location: "Hyderabad, India",
          description:
            "Developed ETL workflows and centralized data platforms for finance and healthcare clients, leveraging AWS Data Pipeline and Apache Spark.",
          color: "#ffcc00",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description: "Some of my published Articles, Blogs and Research.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "neuro-symbolic-sudoku-solver",
      name: "Neuro-Symbolic Sudoku Solver",
      createdAt: "2023-07-02T00:00:00Z",
      description: "Paper published in KDD KiML 2023",
      url: "https://arxiv.org/abs/2307.00653",
    },
    {
      id: "mdp-diffusion",
      name: "MDP-Diffusion",
      createdAt: "2023-09-19T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/mdp-diffusion/",
    },
    {
      id: "consistency-models",
      name: "Consistency Models",
      createdAt: "2023-10-12T00:00:00Z",
      description: "Blog published in Paperspace",
      url: "https://blog.paperspace.com/consistency-models/",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "animated_praveen.png",
    description:
      "Feel free to reach out! I'm available across multiple platforms and typically respond within 24 hours. I can assist with Data Engineering, AI, Cloud Infrastructure, and Full Stack Development projects.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I share my insights on Data Engineering, AI advancements, and my professional journey in the tech world.",
    link: "https://medium.com/@praveensamineni",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Austin, TX, USA",
    locality: "Austin",
    country: "USA",
    region: "Texas",
    postalCode: "73301",
    streetAddress: "Downtown Austin",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.app.goo.gl/abcd1234",
  },
  phoneSection: {
    title: "Phone",
    subtitle: "+1 512-712-6615",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
